import axios from "axios";
import { localizeProducts } from "./langs";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(async (r) => {
  if (/\/public\/shop\/products/.test(r.config?.url || "")) r.data = await localizeProducts(r.data);
  return r;
});

const NET = {
  it: "Problema di connessione. Controlla Internet e riprova.",
  en: "Connection problem. Check your internet connection and try again.",
  fr: "Problème de connexion. Vérifiez Internet et réessayez.",
  de: "Verbindungsproblem. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
  es: "Problema de conexión. Comprueba Internet y vuelve a intentarlo.",
  ru: "Проблема с подключением. Проверьте интернет и попробуйте снова.",
  pt: "Problema de conexão. Verifique a internet e tente novamente.",
  ko: "연결에 문제가 있습니다. 인터넷을 확인하고 다시 시도해 주세요.",
};
const SRV = {
  it: "Servizio momentaneamente non disponibile. I tuoi dati non sono stati inviati: riprova tra poco.",
  en: "The service is temporarily unavailable. Your details were not sent: please try again shortly.",
  fr: "Service momentanément indisponible. Vos données n'ont pas été envoyées : réessayez dans un instant.",
  de: "Der Dienst ist vorübergehend nicht verfügbar. Ihre Daten wurden nicht gesendet: bitte gleich erneut versuchen.",
  es: "Servicio no disponible por el momento. Tus datos no se han enviado: vuelve a intentarlo en breve.",
  ru: "Сервис временно недоступен. Ваши данные не отправлены: попробуйте чуть позже.",
  pt: "Serviço temporariamente indisponível. Seus dados não foram enviados: tente novamente em instantes.",
  ko: "일시적으로 서비스를 이용할 수 없습니다. 입력하신 정보는 전송되지 않았습니다. 잠시 후 다시 시도해 주세요.",
};
const pageLang = () => (document.documentElement.getAttribute("data-lang") || document.documentElement.lang || "it").slice(0, 2);
export const netMsg = () => NET[pageLang()] || NET.it;

export function apiErr(e, fallback = "Si è verificato un errore. Riprova.") {
  if (e && !e.response && (e.request || e.code === "ERR_NETWORK" || e.code === "ECONNABORTED")) return netMsg();
  const detail = e?.response?.data?.detail;
  if (e?.response?.status >= 500 && typeof detail !== "string") return SRV[pageLang()] || SRV.it;
  if (detail == null) return e?.response ? (SRV[pageLang()] || SRV.it) : (e?.message || fallback);
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
